import { useEffect, useState } from 'react';

// Small shared loader so every page handles loading and failure the same way
// instead of each one silently rendering an empty table.
export default function useFetch(fn, deps = []) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let live = true;
    setLoading(true);
    setError(null);
    fn()
      .then((d) => { if (live) setData(d); })
      .catch((e) => { if (live) setError(e.message || 'Could not load'); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, loading, error };
}
